import { MicroLanguageListType } from "types/Common";

export const ERROR_MESSAGE: MicroLanguageListType[] = [
  {
    code: 403,
    title: {
      ko: "잘못된 접근입니다.",
      en: "Unauthorized access.",
      ja: "アクセスできません。",
    },
    text: {
      ko: "잘못된 접근입니다.\n다시 시도해주세요!",
      en: "You've made an unauthorized access attempt.\nPlease try again!",
      ja: "アクセスできません。\nもう一度お試しください!",
    },
  },
  {
    code: 404,
    title: {
      ko: "요청하신 페이지를 찾을 수 없습니다.",
      en: "Page not found.",
      ja: "お探しのページは見つかりません。",
    },
    text: {
      ko: "페이지의 주소가 잘못 입력되었거나\n변경, 삭제되었습니다.\n주소를 다시 확인해주세요!",
      en: "The address might be incorrect\nchanged or deleted.\nPlease check again!",
      ja: "ページのURLが正しく入力されていないか\nページが変更、削除された可能性があります。\nURLをもう一度ご確認ください!",
    },
  },
  {
    code: 500,
    title: {
      ko: "죄송합니다. 현재 서비스 이용이 원활하지 않습니다.",
      en: "We apologize for the service interruptions.",
      ja: "申し訳ございません。現在サービスがご利用頂けません。",
    },
    text: {
      ko: "이용에 불편을 드려 죄송합니다.\n잠시 후 다시 이용해주세요!",
      en: "We apologize for the inconvenience\nPlease try again later!",
      ja: "ご迷惑をおかけいたしまして申し訳ございません。\nお手数ですが、時間をおいてからもう一度ご利用ください!",
    },
  },
];

export const GO_HOME_MESSAGE = {
  ko: "홈으로 돌아가기",
  en: "Go to Home",
  ja: "ホームに戻る",
};
